import { render, staticRenderFns } from "./purchaseReturn.vue?vue&type=template&id=6c0ef9e0&scoped=true&"
import script from "./purchaseReturn.vue?vue&type=script&lang=js&"
export * from "./purchaseReturn.vue?vue&type=script&lang=js&"
import style0 from "./purchaseReturn.vue?vue&type=style&index=0&id=6c0ef9e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0ef9e0",
  null
  
)

export default component.exports